const commonTranslation = {
  hello: "Hello",
  welcome: "Welcome",
  english: "English",
  german: "German",
  italian: "Italian",
  french: "French",
  currentLanguage: "en-US",
  notAvailable: "N/A",
  close: "Close",
  preview: "Preview",
  invoiceDocument: "Invoice document",
  zoomIn: "Zoom in",
  zoomOut: "Zoom out",
  rotateRight: "Rotate right",
  rotateLeft: "Rotate left",
  resetZoom: "Reset zoom",
  previousPage: "Previous page",
  nextPage: "Next page",
  showPassword: "Show password",
  hidePassword: "Hide password",
  qrCode: "QR code",
  drag: "Drag to reorder",
  clickToRefresh: "Click to refresh",
  sampleComponent: "Sample component",
  sidebar: "Sidebar",
  invalidCredentials: "Invalid credentials",
  requestFailed: "Could not complete the request",
  toast_error: "Error",
  toast_warning: "Warning",
  toast_success: "Success",
  toast_info: "Information",
  unknownStatus: "Unknown status",
  unknownLanguage: "Unknown language",
  unknownField: "Additional information"
};

const loginComponent = {
  email: "Email",
  emailAddress: "Email Address",
  username: "User name",
  password: "Password",
  login: "Login",
  signUp: "Sign up",
  multifactorAuthentication: "Multifactor authentication",
  OTPCode: "OTP code",
  verifyAndProceed: "Verify & Proceed",
  resendOTP: "Resend OTP",
  readMore: "Read more",
  logout: "Logout",
  loginOrSignup: "Log in",
  loginWelcome: "Welcome back! Please enter your details.",
  enterEmail: "Enter your email",
  enterPassword: "Password",
  getStarted: "Get Started!",
  profile: "Profile",
  assignment_confirmation: "Assignment confirmation",
  revoke_confirmation:"Revoke confirmation",
  verificationRequired: "Verification Required",
  verificationDescription: "Enter the code shown in your authenticator app",
  no_content : "No content",
  loginRemember: "Remember me for 24 hours",
  ForgotPassword: "Forgot password",
  NoAccount: "Don’t have an account?",
  loginAppInfo: "I don’t have access to my Authenticator App",
  loginSuccess: "Login Successful",
  loginError: "Login Error",
  loginHeroTitle: "Welcome to IDP-AI from UpQuAI",
  loginHeroSubtitle: "Where technology meets insurance expertise",
};

const dashboardComponent = {
  gridView: "Grid view",
  tableView: "Table view",
  PDFExtraction: "FNOL Dashboard",
  search: "Search",
  filter: "Filter",
  filters: "Filters",
  sortBy: "Sort by",
  refresh: "Refresh",
  sort: "Sort",
  sortFields: "Sort-Fields",
  edit: "Edit",
  download: "Download",
  versionHistory: "Version History",
  documentName: "Document Name",
  asc: "ASC",
  desc: "DESC",
  operator: "Operator",
  receiverName :  "Receiver Name",
  receiver: "Receiver",
  extractedAt: "Extracted",
  claimAge: "Age",
  claimAgeLegendTitle: "Claim age vs queue average",
  claimAgeLegendBody:
    "Colour shows how long since extraction, relative to the average of the claims currently in view. Green = newer, red = older.",
  claimAgeAvgBaseline: "Queue average: {{age}}",
  claimAgeNewerThanAvg: "{{ratio}}× younger than average",
  claimAgeOlderThanAvg: "{{ratio}}× older than average",
  claimAgeAboutAvg: "About average age",
  claimAgeAverageMark: "Average",
  claimAgeTier_fresh: "Fresh",
  claimAgeTier_typical: "Typical",
  claimAgeTier_aging: "Aging",
  claimAgeTier_stale: "Stale",
  lastModified: "Last Modified",
  noOfPages: "No. Pages",
  status: "Status",
  action: "Action",
  details: "Details",
  generalInformation: "General Information",
  medicine_info: "Medicine Information",
  invoice: "Invoice",
  invoiceDate: "Invoice Date",
  invoiceReference: "Invoice Reference",
  vetName: "Vet Name",
  vetStreet: "Vet Street",
  city: "City",
  postalCode: "Postal Code",
  language: "Language",
  policyholderName: "Policyholder Name",
  policyholderAddress: "Policyholder Street",
  treatment: "Treatment",
  treatmentDate: "Treatment Date",
  diagnosis: "Diagnosis",
  itemName: "Item name",
  quantity: "Qty",
  prize: "Price",
  VAT: "VAT",
  addTreatment: "Add Treatment",
  addItem: "Add Item",
  total: "Total",
  subTotal: "Sub total",
  calculatedSum: "Calculated Total Sum After Discount",
  notes: "Notes",
  page: "Page",
  pages: "Pages",
  min: " Min",
  mins: " Mins",
  hour: " Hour",
  hours: " Hours",
  day: " Day",
  days: " Days",
  month: " month",
  months: " months",
  ago: "ago",
  timeAgoPhrase: "{{count}} {{unit}} ago",
  modifiedBy: "Modified by",
  modifiedAt: "Modified at",
  clickASC: "Click to sort ascending",
  clickDESC: "Click to sort descending",
  petName: "Pet Name",
  items: "Items",
  treatmentName: "Treatment Name",
  InvoiceTotalSumPriceWithoutVAT: "Invoice Total Sum Price Without VAT",
  InvoiceTotalSumPriceWithVAT: "Invoice Total Sum Price With VAT",
  CalculatedTotalSum: "Calculated Total Sum",
  TotalDiscountAmount: "Total Discount Amount",
  CalculatedTotalSumAfterDiscount: "Calculated Total Sum After Discount",
  recent: "Recent",
  viewHistory: "View History",
  remember: "Don't ask again today",
  rememberSentance : "We will not ask for a verification code again today on your trusted device when you log in.",
  Complete_login : "Complete Login",
  date: "Date",
  time: "Time",
  note: "Note",
  comment : "Comments",
  revoke: "Revoke",
  deleteTreatment:"Delete treatment",
  deleteItem:"Delete item",
  lastUpdate:"Last Update",
  board:"Board",
  table:"Table",
  modified:"Modified by",
  showing:"Showing",
  totalSum:"Total Sum",
  of: "of",
  none: "None",
  customVAT: "Custom VAT",
  quality_level: "Quality Level",
  good: "Good",
  verify: "Verify",
  not_extracted: "Not Extracted",
  apply: "Apply",
  kpiTotal: "Total",
  kpiNotStarted: "Not started",
  kpiInProgress: "In progress",
  kpiCompleted: "Completed",
  kpiNeedsVerification: "Needs verification",
  kpiFailed: "Failed",
  archive: "Archive",
  reprocess: "Reprocess",
  archiveConfirmTitle: "Archive document",
  archiveConfirmContent: "Archive this document? It will disappear from the queue but stays in the history.",
  reprocessConfirmTitle: "Reprocess document",
  reprocessConfirmContent: "Send this document back through extraction? Current data will be replaced.",
  failureReason: "Failure reason",
  receivedFrom: "Received from",
  receivedAt: "Received at",
  documentPreview: "Document preview",
  failure_invalid_file_format: "Invalid file format — the file could not be read.",
  failure_invalid_pet_invoice: "Not a valid pet invoice — no invoice data was detected.",
  failure_extraction_issue: "Extraction error — processing failed unexpectedly.",
  documentArchived: "Document archived",
  documentReprocessing: "Document sent for reprocessing",
  archiveError: "Could not archive the document",
  reprocessError: "Could not reprocess the document",
  countsError: "Could not load the counters",
  viewDetails: "View details",
  dateFrom: "From",
  dateTo: "To",
  dateRange: "Date range",
  searchPlaceholderExtended: "Search file, policyholder, vet, invoice no.",
  noteBy: "by",
  addNote: "Add note",
  writeNote: "Write a note...",
  notesLog: "Notes",
  duplicateWarning: "Possible duplicate: another document has the same invoice reference and policyholder.",
  checkingDuplicate: "Checking for duplicates...",
  fieldsNeedAttention: "fields need attention",
  allFieldsComplete: "All fields complete",
  vatBreakdown: "VAT breakdown",
  vatRate: "VAT rate",
  netAmount: "Net",
  vatAmount: "VAT",
  grossAmount: "Gross",
  totalsMatch: "Calculated sum matches the invoice total",
  totalsDelta: "Difference to invoice total",
  undoMyEdits: "Undo my edits",
  restoreOriginal: "Restore original extraction",
  undoMyEditsContent: "Discard all your unsaved edits on this document?",
  restoreOriginalContent: "Restore the original extraction from the server? All your changes will be lost.",
  moveToTreatment: "Move to treatment",
  duplicateItem: "Duplicate item",
  moveUp: "Move up",
  moveDown: "Move down",
  quantityTimesPrice: "Qty × Price",
  fullscreen: "Fullscreen",
  exitFullscreen: "Exit fullscreen",
  thumbnails: "Thumbnails",
  pageOf: "of",
  invalidPostalCode: "Enter a valid postal code (4 digits)",
  overrideAuto: "Override the auto-calculated value with a manual entry",
  discountAppliedAfterSubtotal: "Applied after the subtotal",
  verificationCompare: "Verification: legacy sum {{legacy}} vs quantity-aware sum {{quantityAware}}",
  jumpToNextAttention: "Jump to the next field that needs attention (Alt+N)",
  moreActions: "More actions"
};

const commonEvents = {
  add: "Add",
  update: "Update",
  save: "Save",
  cancel: "Cancel",
  reset: "Reset",
  download: "Download",
  clear: "Clear",
  delete: "Delete",
  assign: "Assign",
  back: "Back",
  resetInitial: "Reset to initial",
  enter_notes: "Enter your notes here...",
  Updated : "Updated",
  Exported : "Exported",
  Revoked: "Revoked",
  Assigned: "Assigned",
  medicineDescription: "Medicine Description",
  purpose: "Purpose",
  usedFor: "Used For",
  petTypes: "Pet Types",
  activeIngredients: "Active Ingredients",
  category: "Category",
  aiCategory: "AI category",
  exclusionSubcode: "Exclusion subcode",
  reasoning: "Category feedback",
  detection_keywords: "Detection keywords",
  translateReasonings: "Translate category feedback",
  translateReasoningsSuccess: "Category feedback translated",
  translateReasoningsEmpty: "No category feedback to translate",
  translateReasoningsTo: "Translate to {{language}}",
  unclassified: "Unclassified",
  reasonForChange: "Reason for change",
  reasonForChangePlaceholder: "Select a reason",
  changeContext: "Additional context",
  changeContextPlaceholder: "Add more detail about why the classification was updated",
  showMore: "Show more",
  showLess: "Show less",
  typeOfDamage: "Type of Damage",
  causeOfDamage: "Cause of Damage",
  loading: "Loading...",
  confidenceHigh: "High confidence",
  confidenceMedium: "Medium confidence",
  confidenceLow: "Low confidence",
  feedbackReasonDiagnosis: "Diagnosis",
  feedbackReasonTreatmentContext: "Treatment context",
  feedbackReasonItemTextOrOcr: "Item text or OCR",
  feedbackReasonExclusionRule: "Exclusion rule",
  feedbackReasonInvoiceContext: "Invoice context",
  feedbackReasonDuplicateOrWrongLine: "Duplicate or wrong line",
  feedbackReasonExpertJudgment: "Expert judgment",
  feedbackReasonOther: "Other",
  required: "required",
  feedbackOriginal: "Original AI classification",
  feedbackCorrected: "Corrected classification",
  feedbackStatusDraft: "Unsaved classification correction",
  feedbackStatusPending: "Saving classification feedback…",
  feedbackStatusSaved: "Classification feedback saved",
  feedbackStatusError: "Classification feedback failed",
  feedbackValidationTitle: "Classification feedback needs attention",
  feedbackValidationDescription: "Fix the highlighted classification fields before saving.",
  feedbackReasonRequired: "Select a reason for this correction.",
  feedbackContextRequired: "Add context when the reason is Other.",
  feedbackContextTooLong: "Context must be {{max}} characters or fewer.",
  feedbackExclusionSubcodeRequired: "Select a valid exclusion subcode.",
  feedbackNonExclusionSubcode: "Exclusion subcodes are only valid for category E.",
  invalidCategory: "Select a valid category.",
  feedbackSaveFailed: "Classification feedback was not saved",
  feedbackConflict: "This correction was already submitted or conflicts with a newer correction.",
  feedbackStale: "The AI prediction changed. Reload the document before correcting it.",
  feedbackNetworkError: "The correction could not be saved. Your draft is preserved; try again.",
  feedbackUnavailableLegacy: "This AI category cannot be corrected because it was not saved for learning. Reload the document, or reprocess it if it stays locked.",
  feedbackUnavailableRetrying: "The AI category is still being saved. Reload the document in a few minutes to correct it.",
  feedbackUnavailableNotStored: "This AI category cannot be corrected because it was not saved to the learning log. Reprocess the document.",
  feedbackUnavailableDisabled: "Category corrections are not enabled in this environment. The category is visible but cannot be saved.",
  feedbackIdentityRequired: "This correction cannot be saved because the item or AI prediction identity is missing. Reload or reprocess the document.",
  feedbackDuplicateItemId: "This document contains the same item identity more than once. Saving is blocked; reload or reprocess the document.",
  cat_T: "Medical Treatment",
  cat_D: "Death / Disability",
  cat_QS: "Preventive Screening",
  cat_QP: "Prophylaxis",
  cat_C: "Complementary Therapy",
  cat_V: "Vaccination",
  cat_Dx: "Advanced Diagnostics",
  cat_G: "Dietary Foods",
  cat_H: "Therapy Sessions",
  cat_J: "Behavioral Therapy",
  cat_W: "Hospitalization",
  cat_X: "Retained Bonus",
  cat_S: "Rescue Services",
  cat_A: "Direct Payment",
  cat_R: "Veterinary Reports",
  cat_E: "Exclusion",
  exc_g: "Transport costs",
  exc_x: "Administrative fees",
  exc_z: "VAT",
  exc_p: "Passport examinations",
  exc_q: "Electronic chip costs",
  exc_i: "Cremation / Incineration",
  exc_b: "Horseshoeing",
  exc_s: "Elective sterilization",
  exc_c: "Boarding costs",
  exc_m: "Non-medical care",
  exc_d: "Dental care exclusion",
  exc_r: "Veterinary report costs",
  operatorFallback: "Calingo operator"
};

const documentStatus = {
  not_yet_started: "Not started",
  in_progress: "In progress",
  completed: "Completed",
};

const confirmationMessage = {
  deleteConfirmationTitle: "Delete confirmation",
  deleteActionTreatmentContent:
    "Are you sure you want to delete this treatment? This action cannot be undone.",
  deleteActionItemContent:
    "Are you sure you want to delete this item? This action cannot be undone.",
  resetConfirmationTitle: "Reset confirmation",
  resetToInitialConfirmationTitle: "Reset to initial confirmation",
  resetActionContent:
    "Are you sure you want to reset? This action cannot be undone",
  resetInitialActionContent:
    "Are you sure you want to reset to the initial stage? This action cannot be undone",
  assignmentConfirmation:
    "Are you sure you want to assign this document to yourself?",
  revokeConfirmation: "Are you sure you want to unassign this document from yourself?",
  reAssignConfirmation:
    "Are you sure you want to reassign this document to yourself?",
  assignedTo: "This document is assigned to",
};

const errorNotification = {
  invalidEmail: "Please enter a valid email",
  emailEmpty: "Please enter your email",
  passwordEmpty: "Please enter your password",
  notAllowedToEdit: "This document cannot be edited",
  noteNotSaved: "Notes are not being saved",
  tokenExpired: "Your session has expired. Please log in again.",
  accessDenied: "Access denied",
  notAssigned: "Kindly assign the document to yourself for access",
  documentListError: "Could not load the document list",
  genericError: "Something went wrong",
};

const successNotification = {
  DocumentResetToInitial : "The document was restored to its initial state",
  UpdateSuccess: "Updated successfully",
  noteSaved: "Notes have been saved successfully",
  successDocumentProgressStatus: "Assignment successful",
  revokeDocument: "Assignment revoked",
}

const batch1Ux = {
  saveAndNext: "Save & Next",
  complete: "Complete",
  completeAndDownload: "Complete & Download",
  completeConfirmTitle: "Complete document",
  completeConfirmContent: "This marks the document as completed. Continue?",
  startProcessing: "Start processing",
  takeOver: "Take over",
  readOnlyAssignedTo: "Read-only — this document is assigned to {{name}}",
  readOnlyNotAssigned: "This document is not assigned yet — assign it to start processing",
  savedAt: "Saved {{time}}",
  unsavedChanges: "Unsaved changes",
  unsavedChangesTitle: "Unsaved changes",
  unsavedChangesContent: "You have unsaved corrections. Leave without saving?",
  restore: "Restore",
  discard: "Discard",
  restoreDraftTitle: "Restore unsaved draft?",
  restoreDraftContent: "A locally saved draft of your unsaved corrections was found for this document.",
  leave: "Leave",
  stay: "Stay",
  queueEmpty: "Queue is empty — no more invoices to process",
  markedCompleted: "Document marked as completed",
  moreActions: "More",
  lastUpdated: "Last updated {{time}}",
  mine: "mine",
  failed: "Failed",
  completedToday: "Completed today",
  clearAllFilters: "Clear all filters",
  selectedCount: "{{count}} selected",
  assignToMe: "Assign to me",
  markCompleted: "Mark completed",
  exportSelected: "Export selected",
  bulkAssignDone: "{{count}} assigned to you, {{skipped}} skipped",
  bulkCompleteDone: "{{completed}} completed, {{skipped}} skipped",
  bulkExportDone: "{{count}} documents downloaded",
  notAllowedToEditReason: "The document could not be extracted (invalid file or unreadable content), so there is nothing to correct.",
  totalsMatch: "Calculated CHF {{calculated}} matches invoice total CHF {{total}}",
  totalsDelta: "Calculated CHF {{calculated}} · invoice total CHF {{total}} · difference CHF {{diff}}",
  previewDocument: "Preview document",
  previewNotAvailable: "Preview is not available for this document.",
  openedAt: "Last opened {{time}}",
  recentlyModified: "Recently modified",
  recentlyOpened: "Recently opened",
  recentlyExtracted: "Recently extracted",
  noRecentDocuments: "No recent documents",
  chooseAvatar: "Choose animal avatar",
  chooseAvatarHint: "Pick an animal. Each one can only be used by one operator.",
  avatarLoadError: "Could not load animal avatars",
  avatarSaveSuccess: "Animal avatar saved",
  avatarSaveError: "Could not save animal avatar",
  avatarTaken: "That animal is already taken",
  avatarTakenBy: "Taken by {{name}}",
  animalAvatar_dog: "Dog",
  animalAvatar_cat: "Cat",
  animalAvatar_fox: "Fox",
  animalAvatar_owl: "Owl",
  animalAvatar_bear: "Bear",
  animalAvatar_rabbit: "Rabbit",
  animalAvatar_panda: "Panda",
  animalAvatar_lion: "Lion",
  animalAvatar_tiger: "Tiger",
  animalAvatar_wolf: "Wolf",
  animalAvatar_deer: "Deer",
  animalAvatar_hedgehog: "Hedgehog",
  animalAvatar_koala: "Koala",
  animalAvatar_penguin: "Penguin",
  animalAvatar_otter: "Otter",
  animalAvatar_squirrel: "Squirrel",
  animalAvatar_eagle: "Eagle",
  animalAvatar_dolphin: "Dolphin",
  animalAvatar_horse: "Horse",
  animalAvatar_frog: "Frog",
  reSubmitted: "Re-submitted",
  uploadInvoice: "Upload invoice",
  invoiceFile: "Invoice file",
  selectInvoiceFile: "Click or drag an invoice here",
  supportedInvoiceFiles: "JPG, JPEG, PNG, PDF or HEIC · max. 14 MiB",
  inboxType: "Inbox type",
  description: "Description",
  invoiceFileRequired: "Select one invoice file",
  invoiceFileTypeError: "Use a JPG, JPEG, PNG, PDF or HEIC file",
  invoiceFileSizeError: "The file must not exceed 14 MiB",
  invoiceUploadSuccess: "Invoice uploaded",
  invoiceUploadError: "Could not upload the invoice",
};

const authManagement = {
  inviteOnlySignup: "Accounts are available by invitation.",
  invalidInvitation: "This invitation is invalid, expired, or already used.",
  acceptInvitation: "Accept invitation",
  name: "Name",
  confirmPassword: "Confirm password",
  passwordsDoNotMatch: "Passwords do not match",
  invitationAccepted: "Invitation accepted. Sign in to enroll MFA.",
  backToLogin: "Back to login",
  forgotPasswordInstructions: "Enter your email to receive a verification code.",
  passwordResetEmailSent: "If the account exists, a code has been sent.",
  sendCode: "Send code",
  verifyCode: "Verify code",
  invalidOrExpiredCode: "The code is invalid or expired.",
  resendUnavailable: "A new code cannot be sent yet.",
  resetPassword: "Reset password",
  invalidResetLink: "The reset grant is invalid or expired.",
  passwordPolicy: "Use 12+ characters with upper, lower, number and symbol.",
  passwordResetComplete: "Password reset complete.",
  mfaRecovery: "MFA recovery",
  recoveryCodeSent: "A recovery code was sent to {{email}}.",
  recoveryMustStartAtLogin: "Start recovery from the MFA login screen.",
  waitingForAdminApproval: "Email verified. Waiting for administrator approval.",
  refreshStatus: "Refresh status",
  recoveryRejected: "The recovery request was rejected.",
  setupNewAuthenticator: "Set up a new authenticator",
  usersAndInvitations: "Users & invitations",
  inviteUser: "Invite user",
  inviteLanguage: "Invitation language",
  inviteLanguageHint: "Language used for the invitation email.",
  langGerman: "German",
  langEnglish: "English",
  langFrench: "French",
  langItalian: "Italian",
  used: "Used seats",
  licensed: "Licensed seats",
  available: "Available seats",
  users: "Users",
  invitations: "Invitations",
  role: "Role",
  status: "Status",
  actions: "Actions",
  promote: "Promote",
  demote: "Demote",
  activate: "Activate",
  deactivate: "Deactivate",
  deliveryStatus: "Delivery",
  expiresAt: "Expires",
  requestedAt: "Requested",
  resend: "Resend",
  revoke: "Revoke",
  resendInvitation: "Resend invitation",
  revokeInvitation: "Revoke invitation",
  approve: "Approve",
  reject: "Reject",
  approveRecovery: "Approve MFA recovery",
  rejectRecovery: "Reject MFA recovery",
  confirmAdminAction: "Confirm this admin action with your password",
  confirmWithPassword: "Your administrator password",
};

export const enJSON = {
  ...commonEvents,
  ...loginComponent,
  ...dashboardComponent,
  ...errorNotification,
  ...commonTranslation,
  ...documentStatus,
  ...confirmationMessage,
  ...successNotification,
  ...batch1Ux,
  ...authManagement
};
